export function status(arr) {
  let newArr = arr.filter(item => item.status == 0)
  return newArr
}

/**
 * Promise.allSettled() 的实现函数
 * 等待所有 Promise 完成（无论成功或失败），返回包含每个 Promise 结果的数组
 * @param {Iterable} promises - Promise 数组或可迭代对象
 * @returns {Promise} 返回一个 Promise，解析为结果数组
 */
export function allSettled(promises) {
  return new Promise((resolve) => {
    const promiseArray = Array.from(promises)
    const results = []
    let completedCount = 0
    
    if (promiseArray.length === 0) {
      resolve([])
      return
    }
    
    promiseArray.forEach((promise, index) => {
      Promise.resolve(promise)
        .then(value => {
          results[index] = { status: 'fulfilled', value }
        })
        .catch(reason => {
          results[index] = { status: 'rejected', reason }
        })
        .finally(() => {
          completedCount++
          if (completedCount === promiseArray.length) {
            resolve(results)
          }
        })
    })
  })
}




// WEBPACK FOOTER //
// ./src/utils/filter.js